<ng-container *ngIf="isBrowser">
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">{{'Hotelkategorie ab'}}</span>
        <div class="tmp-section-body">
            <ng-container *ngFor="let k of tmparr">
                <button (click)="select(k)">
                    <mat-icon class="tmp-stars">{{ k <= selectedCat ? 'star' : 'star_border' }}</mat-icon>
                </button>
            </ng-container>
        </div>
    </div>
</ng-container>